import React, { useState } from 'react';
import styled from "styled-components";
import TooltipIconButton from "components/TooltipIconButton";
import SearchInput from '../../../SearchInput';

const ShareLocation = styled.div`
  position: relative;
  padding-bottom:1.5rem;

  small {
    margin-left: 43px;
    
    &:hover {
      color: #e5e5e5;
      text-decoration: underline;
    }
  }
`;

const ProjectLocation = ({ edit, location, handle_location }) => {
  //const [locationValue, setLocation] = useState(location);
  const [copied, setCopied] = useState(false);

  // TO DO - handle change + handle errors
  const handleLocation = e => {
    //setLocation(e.target.value);
    //handle_location(e.target.value);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
  }

  return (
    <>
      {edit ?
        <SearchInput
          id="project_location"
          label="Location"
          page="editlocation"
          //placeholder="Enter Location"
          value={location}
        //onChange={handleLocation}
        /> :
        <ShareLocation>
          <TooltipIconButton title={copied ? "Copied to Clipboard" : "Share Location"} ariaLabel="share-location" placement="top" size={44} position="true" top={-9} left={-10} onClick={copyToClipboard} onMouseLeave={() => { setCopied(false); }}>
            <span className="material-icons-outlined">share_location</span>
          </TooltipIconButton>
          <small>{location}</small>
        </ShareLocation>
      }
    </>
  )
}

export default ProjectLocation;